/* eslint-disable new-cap */
import type { mxCell, mxGraph } from '@deity-io/mxgraph'; // <- import types only
import mx from 'services/mxGraph/mx'; // <- import values from factory()
import { MappingSide } from './nodes.types';

export const addPorts = (ports: {}, parentField: mxCell, graph: mxGraph, connectable = true) => {
  // Adds the ports at various relative locations
  Object.keys(ports).forEach((p: any) => {
    const port = graph.insertVertex(
      parentField,
      null,
      { ...ports[p], key: p },
      ports[p].position.x,
      ports[p].position.y,
      18,
      18,
      'port',
      true
    );
    port.geometry.offset = new mx.mxPoint(-9, -9);
    port.isPort = true;
    port.setConnectable(connectable);
  });
};

export const getMappingFieldPortProps = (side: MappingSide): [xPosition: number, color: string, borderColor: string] =>
  side === MappingSide.SOURCE ? [1, '#ffffff', '#DADFE4'] : [0, '#DADFE4', '#C1C8D0'];
